import Swiper from 'swiper'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'

const swiper = new Swiper('.slider-logo', {
  modules: [Autoplay],
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true
  // },
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 12,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
})

const swiperDiaporama = new Swiper('.swiper', {
  modules: [Pagination, Autoplay],
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  slidesPerView: 'auto',
  spaceBetween: 12,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
})
// const logos = document.querySelector()